import { AgGridModule } from "@bfx/ag-grid-angular";
import { CheckboxModule } from "@bfx/primeng/checkbox";
import { CommonModule } from "@angular/common";
import { DataTableModule } from "@bfx/primeng/datatable";
import { FormsModule } from "@angular/forms";
import { InputTextModule } from "@bfx/primeng/inputtext";
import { NgModule } from "@angular/core";
import { PERFECT_SCROLLBAR_CONFIG } from "@bfx/ngx-perfect-scrollbar";
import { PerfectScrollbarConfigInterface } from "@bfx/ngx-perfect-scrollbar";
import { PerfectScrollbarModule } from "@bfx/ngx-perfect-scrollbar";
import { TabViewModule } from "@bfx/primeng/tabview";
import { TooltipModule } from "@bfx/primeng/tooltip";
import { TranslateModule } from "@ngx-translate/core";

import { BfxSharedModule } from "../bfx-shared/bfx-shared.module";
import { NativeDesktopModule } from "../bfx-native-desktop/native-desktop-support.module";
import { BfxATDLDesignerComponent } from "./bfx-atdl-designer.component";
import { FlexLayoutModule } from "@angular/flex-layout";
import { OrderEntryModule } from "app/order-entry/order-entry.module";
import { SplitterModule } from "@bfx/primeng/splitter";
import { ATDLParserService } from "app/order-entry/services/atdl/atdl-parser.service";
import { ATDLUtilityService } from "app/order-entry/services/atdl/atdl-utility.service";
import { ATDLValidatorService } from "app/order-entry/services/atdl/atdl-validator.service";
import { ATDLComparatorService } from "app/order-entry/services/atdl/atdl-comparator.service";
import { ATDLDatasetService } from "app/order-entry/services/atdl/atdl-dataset.service";
import { ATDLProcessorService } from "app/order-entry/services/atdl/atdl-processor.service";
import { BfxATDLDesignerParamsComponent } from "app/bfx-atdl-designer/bfx-atdl-designer-params.component";

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true,
};

@NgModule({
  imports: [
    CommonModule,
    DataTableModule,
    BfxSharedModule,
    TranslateModule,
    TooltipModule,
    FormsModule,
    InputTextModule,
    CheckboxModule,
    NativeDesktopModule,
    TabViewModule,
    PerfectScrollbarModule,
    FlexLayoutModule,
    AgGridModule.withComponents([]),
    OrderEntryModule,
    SplitterModule,
  ],
  providers: [
    ATDLParserService,
    ATDLUtilityService,
    ATDLValidatorService,
    ATDLComparatorService,
    ATDLDatasetService,
    ATDLProcessorService,
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG,
    },
  ],
  declarations: [BfxATDLDesignerComponent, BfxATDLDesignerParamsComponent],
  exports: [BfxATDLDesignerComponent],
  bootstrap: [BfxATDLDesignerComponent],
})
export class BfxATDLDesignerModule {}
